import React from 'react';
import { WysiwygInput, WysiwygInputProps } from 'framework/form';

const ReportWysiwygInput = ({ ...props }: WysiwygInputProps) => {
  const editorConfig = [
    'bold',
    'italic',
    'underline',
    'strikethrough',
    'bulletedList',
    'numberedList',
    'blockQuote',
    'link',
    'alignment',
    'heading',
  ];

  return <WysiwygInput editorConfig={editorConfig} {...props} />;
};

export default ReportWysiwygInput;
